module.exports = __webpack_public_path__ + "img/footer-certified-b-corporation.4d592351.png";